import { IconButton } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { LIST_ROW_HEIGHTS } from '../../../constants/list_row_heights';
import { ITest } from '../../../data/types';
import { testMetaString } from '../../../utils/testMetaString';
import { Column } from '../../layout/Column';
import { Row } from '../../layout/Row';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { List } from '../../shared/List/List';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { ListHeader } from '../../shared/List/ListHeader';
import { ListItem, ListItemCell } from '../../shared/List/ListItem';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import { NoResults } from '../../shared/NoResults';
import { DeleteTest } from '../test/DeleteTest';

interface IProps extends RouteComponentProps {
  data: ITest[];
  selectTest: (t: string) => void;
  selectedTest?: string;
  toggleFeed: () => void;
  feedPaused: boolean;
  loading: boolean;
}

const listShape = [3, 1];
export const ActivityList = withRouter((props: IProps): React.ReactElement => {
  const rowRenderer = ({
    index,
    key,
    style,
  }: {
    index: number;
    key: string;
    style: React.CSSProperties;
  }): React.ReactElement => {
    const row = props.data[index];
    const clickHandler = (): void => props.selectTest(row.id);

    return (
      <ListItem
        onClick={clickHandler}
        key={key}
        style={style}
        selected={row.id === props.selectedTest}
      >
        <ListItemCell style={{ flex: listShape[0] }}>
          <ListAvatar
            entity={row.athlete}
            secondaryText={testMetaString(row.testType.abbr, row.tags)}
          />
        </ListItemCell>
        <ListItemCell style={{ flex: listShape[1] }}>
          <DeleteTest testId={row.id} />
        </ListItemCell>
      </ListItem>
    );
  };

  return (
    <Card style={{ padding: '0px', marginTop: 'var(--grid-gap)' }}>
      <Column>
        <CardHeader>
          <Column>
            <Row>
              <CardHeaderLeft />
              <CardHeaderRight>
                {props.feedPaused ? (
                  <IconButton
                    icon='play_arrow'
                    onClick={props.toggleFeed}
                    title='Resume Live Stream'
                  />
                ) : (
                  <IconButton
                    icon='pause'
                    onClick={props.toggleFeed}
                    title='Pause Live Stream'
                  />
                )}
              </CardHeaderRight>
            </Row>
            <ListHeader labels={['Athlete', 'Actions']} shape={listShape} />
          </Column>
        </CardHeader>
        <CardBody style={{ backgroundColor: 'var(--color-list-background)' }}>
          {props.loading ? (
            <LinearLoading />
          ) : props.data && props.data.length > 0 ? (
            <List
              listLength={props.data.length}
              rowRenderer={rowRenderer}
              rowHeight={LIST_ROW_HEIGHTS.normal}
            />
          ) : (
            <NoResults message='No Tests' />
          )}
        </CardBody>
      </Column>
    </Card>
  );
});
